import React, { useState } from 'react';
import { translate } from '@utils/i18n';
import { WorkspaceHeader } from '@ui/molecules/Header/WorkspaceHeader';
import { Button } from '@ui';
import ContactDyneModal from '../SprinklerSampling/components/ContactDyneModal';
import KitOrderForm from '../SprinklerSampling/components/KitOrderForm';
import { NAMESPACE } from './constants';
import SprinklerProjectionTable from './SprinklerProjectionTable';
import './SprinklerProjectionReportStyles.scss';
export function SprinklerProjectionReport() {
    const [isContactDyneOpen, setIsContactDyneOpen] = useState(false);
    const [isKitOrderOpen, setIsKitOrderOpen] = useState(false);
    return (React.createElement("div", { className: "sprinkler-projection" },
        React.createElement(WorkspaceHeader, { title: translate('title', { namespace: NAMESPACE }), actions: React.createElement(React.Fragment, null,
                React.createElement(Button, { variant: "default", onClick: () => setIsContactDyneOpen(true) }, translate('contact_dyne', { namespace: NAMESPACE })),
                React.createElement(Button, { variant: "primary", onClick: () => setIsKitOrderOpen(true) }, translate('order_kits', { namespace: NAMESPACE }))) }),
        React.createElement("p", { className: "subtitle" }, translate('intro', { namespace: NAMESPACE })),
        React.createElement(SprinklerProjectionTable, null),
        isContactDyneOpen && React.createElement(ContactDyneModal, { onClose: () => setIsContactDyneOpen(false) }),
        isKitOrderOpen && (React.createElement("div", { className: "sprinkler-sampling-container" },
            React.createElement(KitOrderForm, { isOpen: isKitOrderOpen, onClose: () => setIsKitOrderOpen(false) })))));
}
